import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  CreateListing,
  LoadBlogCategories,
  LoadBlogTags,
  ResetBlogState,
} from '../../actions/blog.actions';
import { delay, startWith, take } from 'rxjs/operators';
import * as fromBlog from '../../reducers';
import * as fromRoot from '../../../reducers';
import { ActivatedRoute, Router } from '@angular/router';
import { Unit } from '../../../settings-module/models/unit';
import { selectCurrentUser } from '../../../core/selectors/auth';
import { MatSnackBar } from '@angular/material';
import { BlogService } from '../../../lib/services/blogService';

@Component({
  selector: 'mj-blog-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddComponent implements OnInit, OnDestroy {
  pendingRequest$: Observable<boolean>;
  blogInfoValid$;
  blogListingValid$;
  isCreateSuccess$;
  error$;

  constructor(
    public blogService: BlogService,
    private root_store: Store<fromRoot.State>,
    private store: Store<fromBlog.State>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _snackBar: MatSnackBar
  ) {
    this.resetBlogState();

    this.pendingRequest$ = this.store.select(fromBlog.selectBlogIsLoading).pipe(
      startWith(null),
      delay(0)
    );
    this.store.dispatch(new LoadBlogCategories());
    this.store.dispatch(new LoadBlogTags());

    this.blogInfoValid$ = this.store.select(fromBlog.selectIsBlogInfoValid);
    this.blogListingValid$ = this.store.select(
      fromBlog.selectIsBlogListingValid
    );

    this.isCreateSuccess$ = this.store
      .select(fromBlog.selectIsCreateSuccess)
      .subscribe(success => {
        if (success) {
          this._router.navigate(['dashboard', 'blog']);
        }
      });

    this.error$ = this.store.select(fromBlog.selectError).subscribe(err => {
      if (err) {
        this._snackBar.open(err, null, {
          duration: 3000,
        });
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.resetBlogState();
    this._snackBar.dismiss();

    if (this.isCreateSuccess$) {
      this.isCreateSuccess$.unsubscribe();
    }
  }

  cancelButtonClicked() {
    this.resetBlogState();
    this._router.navigate(['dashboard', 'blog']);
  }

  resetBlogState() {
    const new_job_listing = this.blogService.createEmptyBlogListing();
    this.store.dispatch(new ResetBlogState({ new_listing: new_job_listing }));
  }

  nextStepClicked(step) {
    this._router.navigate([step], { relativeTo: this._route });
  }

  saveBlogClicked() {
    this.store
      .select(fromBlog.selectBlogListing)
      .pipe(take(1))
      .subscribe(current_listing => {
        this.store
          .select(fromRoot.getSelectedUnit)
          .pipe(take(1))
          .subscribe((currentUnit: Unit) => {
            this.store
              .select(selectCurrentUser)
              .pipe(take(1))
              .subscribe(user => {
                current_listing.blog_post.unit = currentUnit;
                current_listing.blog_post.poster = user.currentUser;
                current_listing.blog_post.title =
                  current_listing.blog_listing_items[0].title;
                this.store.dispatch(
                  new CreateListing({
                    listing: current_listing,
                  })
                );
              });
          });
      });
  }
}
